export default __webpack_public_path__ + "static/timberline-healthcare-small-5ce5a01c05667eb72559cccfd03585ef.jpg";